/**
 * Pet User Signups Chart Component
 * - Displays user registration trends over time
 * - Bar chart showing signup patterns
 * - Tracks new pet parent and veterinarian registrations
 */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function PetSignupsChart() {
  const data = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    datasets: [
      {
        label: 'Pet Signups',
        data: [90, 140, 110, 130, 160, 150, 170],
        backgroundColor: '#3b82f6',
        borderColor: '#2563eb',
        borderWidth: 1,
        borderRadius: 4,
        borderSkipped: false,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: '#f3f4f6',
        },
      },
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false,
    },
  };

  return (
    <div className="w-full border-gray-300 border p-3 sm:p-4 py-4 sm:py-5 rounded-lg">
      <div className="mb-4 sm:mb-5 flex flex-col sm:flex-row sm:items-end justify-between gap-2">
        <div>
          <h3 className="text-base sm:text-lg font-semibold text-gray-900">Pet Signups</h3>
          <p className="mt-1 text-xs text-gray-500">
            From Appointments to Earnings - Monthly View
          </p>
          <div className="mt-1 text-xs text-gray-400">July 2, 2025</div>
        </div>
        <div className="text-left sm:text-right">
          <div className="text-2xl sm:text-3xl font-semibold text-blue-600">242</div>
        </div>
      </div>

      <div className="h-48 sm:h-56 w-full">
        <Bar data={data} options={options} />
      </div>

      <div className="mt-3 flex items-center justify-center gap-2 text-sm text-gray-600">
        <span className="inline-block h-2 w-2 rounded-full bg-blue-500" />
        Revenue
      </div>
    </div>
  );
}
